import { Updater } from "@/app/lib/system/immer-wrapper"
// mine:
import { AbstractGameState } from "@/app/lib/game-state/abstract-game-state";
import { PyramidData } from "../system/puzzle-generator";
import { PyramidSnapshot } from "@/app/lib/game-state/pyramid-game-state";
import { StoryLevelData } from "@/app/lib/levels/story-level-data-types";
import { StorySnapshot } from "@/app/lib/game-state/story-game-state";

// Types that help structure our available games
export type TPuzzleData = PyramidData | StoryLevelData;
export type TSnapshot = PyramidSnapshot | StorySnapshot;

// Single source of truth for game modes
const GAME_MODES = ['pyramid', 'story'] as const;
// fancy syntax to convert the array into a type:
export type GameMode = (typeof GAME_MODES)[number];

export function isGameMode(x: unknown) : x is GameMode {
    if (typeof x !== 'string')
        return false;

    // we have to convert to a set to check inclusion in the set
    // if we wanted to do array.includes, we'd need to cast GAME_MODES as a non-const tuple
    const GAME_MODE_SET = new Set<string>(GAME_MODES);
    return GAME_MODE_SET.has(x);
}

// This is the return structure of the hooks that give us the state/updater in single object
// Typed with "extends" so it can work with both child and parent abstract classes
export type GameObj<TState extends AbstractGameState<TPuzzleData, TSnapshot>> = {
    state: TState,
    update: Updater<TState>
}
// We alias them here for easier access:
export type AnyGameObj = GameObj<AbstractGameState<TPuzzleData, TSnapshot>>;
export type AnyGameState = AnyGameObj["state"];